import React, { useEffect } from "react";
import HomePage from "./components/HomePage";
import CarpentryServices from "./components/CarpentryServices";
import ServicePage from "./components/ServicePage";
import AreasHub from "./components/AreasHub";
import AreaPage from "./components/AreaPage";
import AboutUs from "./components/AboutUs";
import OurWork from "./components/OurWork";
import Contact from "./components/Contact";
import SiteCarpentry from "./components/SiteCarpentry";
import NotFound from "./components/NotFound";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { localBusinessSchema } from "./data/site";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
      </Helmet>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/carpentry-services" element={<CarpentryServices />} />
          <Route path="/carpentry-services/:slug" element={<ServicePage />} />
          <Route path="/areas" element={<AreasHub />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
          <Route path="/site-carpentry" element={<SiteCarpentry />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </HelmetProvider>
  );
}

export default App;
